export default __webpack_public_path__ + "static/media/MineaLovelace.eac05fe6.png";